import { Query, readItem, readItems } from "@directus/sdk";
import { GaripalliDirectusClient } from "../directus/client";
import { CityEscape, Props } from "../directus/collections";
import { Schema } from "../directus/schema";

export async function fetchCityEscapes(
  client: GaripalliDirectusClient,
  query?: Query<Schema, CityEscape> | undefined
) {
  return client.request<CityEscape[]>(readItems("city_escapes", query));
}

export async function fetchCityEscapeById(
  client: GaripalliDirectusClient,
  cityEscapeId: string,
  query?: Query<Schema, CityEscape> | undefined
) {
  return client.request<CityEscape>(
    readItem("city_escapes", cityEscapeId, query)
  );
}

